module.exports = __webpack_public_path__ + "img/mail-box.8a20f9cb.svg";